import { BUNDLE_BASE } from "./bundleBase";

const hostMapping = {
  "app.crm4b2c.com": "fieldsales.crm4b2c.com",
  "app.lsq-staging.com": "fieldsales.lsq-staging.com",
  "app.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "app-us11.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "app-ca12.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "app-ir31.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "app-in21.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "app-in22.leadsquared.com": "fieldsales-in22.leadsquared.com",
  "run.crm4b2c.com": "fieldsales.crm4b2c.com",
  "run.lsq-staging.com": "fieldsales.lsq-staging.com",
  "in21.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "us11.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "ir31.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "ca12.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "run.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "in22.leadsquared.com": "fieldsales-in22.leadsquared.com",
};

const mavisHostMapping = {
  "app.crm4b2c.com": "https://mavis-api.crm4b2c.com/",
  "app.lsq-staging.com": "https://mavis-api-in21.lsq-staging.com/",
  "app.leadsquared.com": "https://mavis-rest.leadsquared.com/",
  "app-us11.leadsquared.com": "https://mavis-rest-us11.leadsquared.com/",
  "app-ca12.leadsquared.com": "https://mavis-rest-ca12.leadsquared.com/",
  "app-in21.leadsquared.com": "https://mavis-rest-in21.leadsquared.com/",
  "app-in22.leadsquared.com": "https://mavis-rest-in22.leadsquared.com/",
  "app-ir31.leadsquared.com": "https://mavis-rest-ir31.leadsquared.com/",
  "run.crm4b2c.com": "https://mavis-api.crm4b2c.com/",
  "run.lsq-staging.com": "https://mavis-api-in21.lsq-staging.com/",
  "run.leadsquared.com": "https://mavis-rest.leadsquared.com/",
  "us11.leadsquared.com": "https://mavis-rest-us11.leadsquared.com/",
  "ca12.leadsquared.com": "https://mavis-rest-ca12.leadsquared.com/",
  "in21.leadsquared.com": "https://mavis-rest-in21.leadsquared.com/",
  "in22.leadsquared.com": "https://mavis-rest-in22.leadsquared.com/",
  "ir31.leadsquared.com": "https://mavis-rest-ir31.leadsquared.com/",
}

const cssHostMapping = {
    "app.crm4b2c.com": ".fieldsales.crm4b2c.com",
    "app.lsq-staging.com": ".fieldsales.lsq-staging.com",
    "app.leadsquared.com": "-in21.leadsquared.com",
    "app-us11.leadsquared.com": "-in21.leadsquared.com",
    "app-ca12.leadsquared.com": "-in21.leadsquared.com",
    "app-ir31.leadsquared.com": "-in21.leadsquared.com",
    "app-in21.leadsquared.com": "-in21.leadsquared.com",
    "app-in22.leadsquared.com": "-in22.leadsquared.com",
    "run.crm4b2c.com": ".fieldsales.crm4b2c.com",
    "run.lsq-staging.com": ".fieldsales.lsq-staging.com",
    "in21.leadsquared.com": "-in21.leadsquared.com",
    "us11.leadsquared.com": "-in21.leadsquared.com",
    "ir31.leadsquared.com": "-in21.leadsquared.com",
    "ca12.leadsquared.com": "-in21.leadsquared.com",
    "run.leadsquared.com": "-in21.leadsquared.com",
    "in22.leadsquared.com": "-in22.leadsquared.com",
  };
  const getHostMapping = (host) => {
    if (host.includes("staging")){
      return hostMapping["run.lsq-staging.com"]
    } else if (host.includes("leadsquared.com")){
      return hostMapping["run.leadsquared.com"]
    }
    return hostMapping["run.crm4b2c.com"]
  }

export const mavisHost = mavisHostMapping?.[window.location.host] || mavisHostMapping["run.leadsquared.com"];

// "https://casa-web" moves here from the call sites: cssHost is now a full base URL rather
// than a domain suffix. The map is kept as a fallback so behaviour on the existing CDN is
// unchanged when the bundle URL cannot be read.
const legacyCssHost = `https://casa-web${cssHostMapping?.[window.location.host] || cssHostMapping["run.leadsquared.com"]}`;

export const cssHost = BUNDLE_BASE || legacyCssHost;

export const host = hostMapping?.[window.location.host] || getHostMapping(window.location.host);

/**
 * The NextGen shell publishes its resolved environment config on the window it shares with this
 * microfrontend, under the key its own helpers read (`___env_var___`). IS_CUSTOM_DOMAIN is added
 * to that config by one script -- the shell's custom-domain deploy step -- so its presence is an
 * exact signal, not a heuristic on the hostname, and it is the same flag the shell's own rest
 * client gates its encryption on.
 */
const PLATFORM_ENV_KEY = "___env_var___";

const platformEnvConfig = (key) =>
  typeof window === "undefined" ? undefined : window[PLATFORM_ENV_KEY]?.[key];

export const isCustomDomain = () => Boolean(platformEnvConfig("IS_CUSTOM_DOMAIN"));

/**
 * Empty in every deployment so far, which leaves the crypto library to resolve
 * `${window.location.origin}/api/gw` itself. Read anyway, and read from the shell's config rather
 * than our own, so that if NextGen ever points the handshake somewhere else we follow it instead
 * of opening a second session against a different gateway from inside the same page.
 */
export const gatewayBaseUrlOverride = () => platformEnvConfig("GATEWAY_BASE_URL") || "";

/**
 * Custom domain: the shell serves this app from the tenant's own domain, and appgateway fronts
 * the APIs on that same origin -- it matches /api/fs/** and rewrites the path to /api/** before
 * forwarding to the FieldSales gateway, so `/fs` is inserted after /api rather than prefixed onto
 * the whole path. That route is shared with dashboard, territory and console.
 *
 * Same-origin is not cosmetic: the payload-crypto client resolves its gateway as
 * `${window.location.origin}/api/gw`, so only a same-origin request can be sealed. Everywhere
 * else the host map above still wins and the call stays cross-origin and unsealed, exactly as
 * today.
 */
export const casaServiceBaseUrl = isCustomDomain()
  ? `${window.location.origin}/api/fs/casa-service/v1`
  : `https://${host}/api/casa-service/v1`;

const getRumEnvironment = () => {
  const host = window.location.host;
  if (host.endsWith("marketxpander.net")) return "dev";
  if (host.endsWith("crm4b2c.com"))       return "test";
  if (host.endsWith("lsq-staging.com"))   return "staging";
  if (host.endsWith("leadsquared.com"))   return "production";
  return "local";
};

// Coralogix RUM Browser SDK configuration.
// public_key: obtain from Coralogix UI → Data Flow → RUM → "Add new application".
// coralogixDomain: 'AP1' = app.coralogix.in (Mumbai/Singapore region).
export const monitoringConfig = {
  application: "casa-web-dashboard",
  environment: getRumEnvironment(),
  public_key: getRumEnvironment() === 'production' ? process.env.REACT_APP_CORALOGIX_RUM_PROD_PUBLIC_KEY : process.env.REACT_APP_CORALOGIX_RUM_PUBLIC_KEY || "",
  coralogixDomain: "AP1",
  version: "1.0.0",
  sessionRecordingConfig: {
    enable: false,
  },
  instrumentations: {
    errors:       true,
    fetch:        true,
    xhr:          true,
    web_vitals:   true,
    interactions: true,
    resources:    false,
    long_tasks:   false,
    custom:       true,
  },
};
